module.exports = __webpack_public_path__ + "img/Exhibition_Logo2.79c94d75.jpg";